import { STATE_KEY_NAME } from './constants';

export const getRouting = (state) => state[STATE_KEY_NAME];
export const getCurrentMatch = (state) => getRouting(state).currentMatch;
export const getPreviousMatches = (state) => getRouting(state).previousMatches;
export const getRoute = (state) => getCurrentMatch(state).route;
export const getRouteParams = (state) => getCurrentMatch(state).params;
export const getRouteQueryParams = (state) => getCurrentMatch(state).queryParams;
